import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { BASEAPIURL, token } from "../../env";

const LawnManagement = ({ type }) => {
  // =================== STATE ===================
  const [lawns, setLawns] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [groupFacilities, setGroupFacilities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(null);
  const [locationId, setLocationId] = useState("");
  const [selectedGroupFacility, setSelectedGroupFacility] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showPricingModal, setShowPricingModal] = useState(false);
  const [lawnSpecificPricing, setLawnSpecificPricing] = useState([]);
  const [showSundryModal, setShowSundryModal] = useState(false);
  const [pricingDateFilter, setPricingDateFilter] = useState("");
  const [currentLawn, setCurrentLawn] = useState({
    Lawn_ID: "",
    Lawn_Name: "",
    Lawn_Desc: "",
    Lawn_Location: "",
    BookingCount: 1,
    Type: type === "banquethall" || type === "Hall" ? "Hall" : "Lawn",
    FacilityID: 0,
    LawnPrice: 0.0,
    GuestLawnPrice: 0.0,
    TaxPercentage: 0.0,
    TaxIsInclude: false,
    LocationID: 0,
    EC_LawnType_ID: 0,
    Status: "Active",
  });
  const [pricingForm, setPricingForm] = useState({
    EffectiveDate: "",
    MemberLawnPrice: 0,
    GuestLawnPrice: 0,
    TaxPercentage: 0,
    TaxIsInclude: false,
    LawnTypeDtl_ID: 0,
  });
  const [sundryItems, setSundryItems] = useState([]);
  // Updated initial state to include TaxInclude
  const [sundryForms, setSundryForms] = useState([
    { SundryName: "", Type: "", Price: "", TaxInclude: true },
  ]);
  const [priceList, setPriceList] = useState([]);
  const [effectiveDate, setEffectiveDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  // Sundry modal state
  const [sundryList, setSundryList] = useState([]);
  const [sundryListLoading, setSundryListLoading] = useState(false);

  // API Config
  const TOKEN_DATA = token;
  

  // =================== FETCH FUNCTIONS ===================
  const fetchGroupFacilities = async () => {
    try {
      const url = `${BASEAPIURL}/GetFGrpListS?token=${encodeURIComponent(
        TOKEN_DATA
      )}`;
      const response = await fetch(url);
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      setGroupFacilities(
        result.status && Array.isArray(result.data) ? result.data : []
      );
    } catch (err) {
      setGroupFacilities([]);
      setError("Failed to fetch group facilities");
      console.error("Error fetching group facilities:", err);
    }
  };
  const fetchFacilitiesByGroup = async (groupId) => {
    try {
      const url = `${BASEAPIURL}/GetFacilityBookingByFGrpID?FGrpID=${groupId}&Token=${encodeURIComponent(
        TOKEN_DATA
      )}`;
      const response = await fetch(url);
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      setFacilities(
        result.status && Array.isArray(result.data) ? result.data : []
      );
    } catch (err) {
      setFacilities([]);
      setError("Failed to fetch facilities");
      console.error("Error fetching facilities:", err);
    }
  };
  const fetchLawns = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = `${BASEAPIURL}/GetLawns?Type=${type}&Token=${encodeURIComponent(
        TOKEN_DATA
      )}`;
      const response = await fetch(url);
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        setLawns(result.data);
        setPriceList(result.data);
      } else {
        setLawns([]);
        setPriceList([]);
      }
    } catch (err) {
      setLawns([]);
      setPriceList([]);
      setError("Failed to fetch lawns");
      console.error("Error fetching lawns:", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchLawnPriceList = async (date) => {
    if (!date) return;
    setLoading(true);
    setError(null);
    try {
      const url = `${BASEAPIURL}/GetLawnspricelist?Type=${type}&Token=${encodeURIComponent(
        TOKEN_DATA
      )}&EffectiveDate=${date}`;
      const response = await fetch(url, { method: "GET", redirect: "follow" });
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      let filteredData = [];
      if (result.status && Array.isArray(result.data)) {
        filteredData = result.data.filter((item) => {
          const itemDate = item.EffectiveDate
            ? new Date(item.EffectiveDate).toISOString().split("T")[0]
            : "";
          return itemDate === date;
        });
      }
      setPriceList(filteredData);
    } catch (err) {
      setPriceList([]);
      setError("Failed to fetch price list");
      console.error("Error fetching price list:", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchLocations = async () => {
    try {
      const res = await fetch(`${BASEAPIURL}/LocationList`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: TOKEN_DATA }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      const json = await res.json();
      if (Array.isArray(json.data)) {
        setLocations(json.data);
        if (!locationId && json.data.length > 0) {
          setLocationId(String(json.data[0].LocID));
        }
      } else {
        setLocations([]);
      }
    } catch (err) {
      setLocations([]);
      setError("Failed to fetch locations");
      console.error("Error fetching locations:", err);
    }
  };
  const fetchSundryItems = async (lawnId) => {
    if (!lawnId) {
      setSundryItems([]);
      return;
    }
    try {
      const url = `${BASEAPIURL}/GetSundrybyLawntypeID?token=${encodeURIComponent(
        TOKEN_DATA
      )}&LawntypeID=${lawnId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      const items = Array.isArray(result)
        ? result
        : result.data && Array.isArray(result.data)
        ? result.data
        : [];
      setSundryItems(items);
    } catch (err) {
      setSundryItems([]);
      setError("Failed to fetch sundry items");
      console.error("Error fetching sundry items:", err);
    }
  };
  const fetchPricingForLawn = async (lawnId) => {
    if (!lawnId) {
      setLawnSpecificPricing([]);
      return;
    }
    try {
      // const url = `${BASEAPIURL}/GetLawnTypeDtl?Token=${encodeURIComponent(
      const url = `${BASEAPIURL}/GetLawnTypeDtlByID?Token=${encodeURIComponent(
        TOKEN_DATA
      )}&LawnID=${lawnId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (result.status && Array.isArray(result.data)) {
        setLawnSpecificPricing(result.data);
      } else {
        setLawnSpecificPricing([]);
      }
    } catch (err) {
      setLawnSpecificPricing([]);
      setError("Failed to fetch lawn pricing details");
      console.error("Error fetching pricing for lawn:", err);
    }
  };

  // =================== INITIAL DATA FETCH ===================
  useEffect(() => {
    Promise.all([fetchGroupFacilities(), fetchLawns(), fetchLocations()]).catch(
      (err) => setError("Failed to load initial data")
    );
    fetchFacilitiesByGroup(5);
  }, []);

  // =================== HANDLERS ===================
  const handleGroupFacilityChange = (e) => {
    const groupId = e.target.value;
    setSelectedGroupFacility(groupId);
    if (groupId) {
      fetchFacilitiesByGroup(groupId);
    } else {
      setFacilities([]);
    }
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentLawn((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "BookingCount" ||
            name === "FacilityID" ||
            name === "LocationID" ||
            name === "EC_LawnType_ID"
          ? parseInt(value, 10) || 0
          : name === "LawnPrice" ||
            name === "GuestLawnPrice" ||
            name === "TaxPercentage"
          ? parseFloat(value) || 0
          : value,
    }));
  };
  const handlePricingChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPricingForm((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "MemberLawnPrice" ||
            name === "GuestLawnPrice" ||
            name === "TaxPercentage"
          ? parseFloat(value) || 0
          : value,
    }));
  };
  const handleEditPricing = (lawn) => {
    setPricingForm({
      EffectiveDate: lawn.EffectiveDate || effectiveDate,
      MemberLawnPrice:
        lawn.MemberLawnPrice || lawn.MemberRate || lawn.LawnPrice || 0,
      GuestLawnPrice: lawn.GuestLawnPrice || lawn.GuestRate || 0,
      TaxPercentage: lawn.TaxPercentage || 0,
      TaxIsInclude: lawn.TaxIsInclude || lawn.Is_TaxInclude || false,
      LawnTypeDtl_ID: lawn.LawnTypeDtl_ID || 0,
    });
    setCurrentLawn(lawn);
    setIsEditing(true);
    setShowPricingModal(true);
  };
  const handleSundrySelection = (sundryJson, index) => {
    if (!sundryJson || sundryJson === "0") {
      // Clear selection
      setSundryForms((prev) =>
        prev.map((form, i) =>
          i === index
            ? {
                ...form,
                sundryId: 0,
                SundryName: "",
                Price: "",
                Type: "",
                TaxInclude: true,
                selectedSundry: null,
              } // Reset TaxInclude too
            : form
        )
      );
      return;
    }
    try {
      const selectedSundry = JSON.parse(sundryJson);
      if (selectedSundry) {
        setSundryForms((prev) =>
          prev.map((form, i) =>
            i === index
              ? {
                  ...form,
                  sundryId:
                    selectedSundry.Sundry_ID || selectedSundry.SundryID || 0,
                  EC_sundryId:
                    selectedSundry.LTSundry_EC_SundryID ||
                    selectedSundry.LTSundry_EC_SundryID ||
                    0,
                  SundryName:
                    selectedSundry.LTSundry_Name ||
                    selectedSundry.Sundry_Name ||
                    "",
                  SundryPercentage: selectedSundry.Sundry_Percentage,
                  Price:
                    parseFloat(
                      selectedSundry.LTSundry_Amount || selectedSundry.Amount
                    ) || "",
                  Type: String(
                    selectedSundry.Optional ||
                      selectedSundry.LTSundry_Optional ||
                      "false"
                  ),
                  // Pre-populate TaxInclude from the selected sundry item if available, otherwise default to true
                  TaxInclude:
                    selectedSundry.IsTaxInclud != null
                      ? selectedSundry.IsTaxInclud
                      : true,
                  selectedSundry: selectedSundry,
                }
              : form
          )
        );
      }
    } catch (err) {
      console.error("Failed to parse sundry selection", err);
    }
  };
  const handleSavePricing = async () => {
    if (!pricingForm.EffectiveDate) {
      alert("Please select an effective date");
      return;
    }
    if (pricingForm.MemberLawnPrice < 0 || pricingForm.GuestLawnPrice < 0) {
      alert("Prices cannot be negative");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        token: TOKEN_DATA,
        lawnDtl: {
          EffectiveDate: pricingForm.EffectiveDate,
          LawnType_MainID: currentLawn.Lawn_ID,
          MemberRate: parseFloat(pricingForm.MemberLawnPrice) || 0,
          GuestRate: parseFloat(pricingForm.GuestLawnPrice) || 0,
          TaxPercentage: parseFloat(pricingForm.TaxPercentage) || 0,
          Is_TaxIsInclude: pricingForm.TaxIsInclude ? 1 : 0,
        },
      };
      const response = await fetch(`${BASEAPIURL}/IsertLawnTypeDtl`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (result.status) {
        setCurrentLawn((prev) => ({
          ...prev,
          LawnPrice: pricingForm.MemberLawnPrice,
          GuestLawnPrice: pricingForm.GuestLawnPrice,
          TaxPercentage: pricingForm.TaxPercentage,
          TaxIsInclude: pricingForm.TaxIsInclude,
        }));
        fetchLawnPriceList(pricingForm.EffectiveDate);
        fetchPricingForLawn(currentLawn.Lawn_ID);
        alert("Pricing saved successfully!");
        setShowPricingModal(false);
      } else {
        throw new Error(result.message || "Failed to save pricing");
      }
    } catch (err) {
      setError("Failed to save pricing: " + err.message);
      console.error("Error saving pricing:", err);
    } finally {
      setSaving(false);
    }
  };
  const handleUpdatePricing = async () => {
    if (!pricingForm.EffectiveDate) {
      alert("Please select an effective date");
      return;
    }
    if (pricingForm.MemberLawnPrice < 0 || pricingForm.GuestLawnPrice < 0) {
      alert("Prices cannot be negative");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        token: TOKEN_DATA,
        lawnDtl: {
          EffectiveDate: pricingForm.EffectiveDate,
          LawnType_MainID: currentLawn.Lawn_ID,
          MemberRate: parseFloat(pricingForm.MemberLawnPrice) || 0,
          GuestRate: parseFloat(pricingForm.GuestLawnPrice) || 0,
          TaxPercentage: parseFloat(pricingForm.TaxPercentage) || 0,
          Is_TaxInclude: pricingForm.TaxIsInclude,
        },
      };
      const response = await fetch(
        `${BASEAPIURL}/UpdateLawnTypeDtl?LawnTypeDtl_ID=${pricingForm.LawnTypeDtl_ID}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (result.status) {
        setCurrentLawn((prev) => ({
          ...prev,
          LawnPrice: pricingForm.MemberLawnPrice,
          GuestLawnPrice: pricingForm.GuestLawnPrice,
          TaxPercentage: pricingForm.TaxPercentage,
          TaxIsInclude: pricingForm.TaxIsInclude,
        }));
        fetchLawnPriceList(pricingForm.EffectiveDate);
        fetchPricingForLawn(currentLawn.Lawn_ID);
        alert("Pricing updated successfully!");
        setShowPricingModal(false);
      } else {
        throw new Error(result.message || "Failed to update pricing");
      }
    } catch (err) {
      setError("Failed to update pricing: " + err.message);
      console.error("Error updating pricing:", err);
    } finally {
      setSaving(false);
    }
  };
  const handleAdd = () => {
    setCurrentLawn({
      Lawn_ID: "",
      Lawn_Name: "",
      Lawn_Desc: "",
      Lawn_Location: "",
      BookingCount: 1,
      Type: type === "banquethall" || type === "Hall" ? "Hall" : "Lawn",
      FacilityID: 0,
      LawnPrice: 0.0,
      GuestLawnPrice: 0.0,
      TaxPercentage: 0.0,
      TaxIsInclude: false,
      LocationID: 0,
      EC_LawnType_ID: 0,
      Status: "Active",
    });
    setSundryItems([]);
    setLawnSpecificPricing([]);
    setPricingDateFilter("");
    setIsEditing(false);
    setShowForm(true);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentLawn.Lawn_Name.trim()) {
      setError("Lawn Name is required");
      return;
    }
    setSaving(true);
    try {
      const lawnData = {
        Lawn_Name: currentLawn.Lawn_Name.trim(),
        Lawn_Desc: currentLawn.Lawn_Desc || "",
        Lawn_Location: currentLawn.Lawn_Location || "",
        BookingCount: currentLawn.BookingCount || 0,
        FacilityID: currentLawn.FacilityID || 0,
        LocationID: currentLawn.LocationID || 0,
        LawnPrice: currentLawn.LawnPrice || 0,
        GuestLawnPrice: currentLawn.GuestLawnPrice || 0,
        TaxPercentage: currentLawn.TaxPercentage || 0,
        TaxIsInclude: currentLawn.TaxIsInclude ? 1 : 0,
        EC_LawnType_ID: currentLawn.EC_LawnType_ID || 0,
        Type: currentLawn.Type,
        Status: currentLawn.Status || "Active",
      };
      if (currentLawn.Lawn_ID) {
        lawnData.Lawn_ID = currentLawn.Lawn_ID;
      }
      const payload = { tokenData: TOKEN_DATA, Lawns: lawnData };
      const endpoint = currentLawn.Lawn_ID
        ? `${BASEAPIURL}/UpdateLawn?mainID=${currentLawn.Lawn_ID}`
        : `${BASEAPIURL}/InsertLawn`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (!result.status) {
        throw new Error(result.message || "Action failed");
      }
      setShowForm(false);
      fetchLawns();
      alert("Lawn saved successfully!");
    } catch (err) {
      setError("Failed to save lawn: " + err.message);
      console.error("Error saving lawn:", err);
    } finally {
      setSaving(false);
    }
  };
  const handleEdit = async (lawn) => {
    setCurrentLawn({ ...lawn });
    setIsEditing(true);
    setShowForm(true);
    setPricingDateFilter("");
    setPricingDateFilter(effectiveDate);
    try {
      await Promise.all([
        fetchSundryItems(lawn.Lawn_ID),
        fetchPricingForLawn(lawn.Lawn_ID),
      ]);
    } catch (err) {
      setError("Failed to load sundry items or pricing");
    }
  };
  const handleDelete = async (lawnId) => {
    if (!window.confirm("Are you sure you want to delete this lawn?")) return;
    try {
      const response = await fetch(
        `${BASEAPIURL}/DeleteLawn?LawnID=${lawnId}&Token=${encodeURIComponent(
          TOKEN_DATA
        )}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (result.status) {
        fetchLawns();
        alert("Lawn deleted successfully!");
      } else {
        throw new Error(result.message || "Failed to delete lawn");
      }
    } catch (err) {
      setError("Failed to delete lawn: " + err.message);
      console.error("Error deleting lawn:", err);
    }
  };
  const closePricingModal = () => {
    setShowPricingModal(false);
    setPricingForm({
      EffectiveDate: "",
      MemberLawnPrice: 0,
      GuestLawnPrice: 0,
      TaxPercentage: 0,
      TaxIsInclude: false,
      LawnTypeDtl_ID: 0,
    });
  };
  const closeForm = () => {
    setShowForm(false);
    setPricingDateFilter("");
  };

  // Sundry Form Handlers - RESTORED MULTIPLE ITEM FUNCTIONALITY
  const openSundryModal = () => {
    fetchSundryList();
    // Reset the form to a single empty item with TaxInclude when opening
    setSundryForms([{ SundryName: "", Type: "", Price: "", TaxInclude: true }]);
    setShowSundryModal(true);
  };
  const handleSundryFormChange = (index, field, value) => {
    setSundryForms((prev) =>
      prev.map((form, i) => (i === index ? { ...form, [field]: value } : form))
    );
  };
  const addSundryField = () => {
    setSundryForms((prev) => [
      ...prev,
      { SundryName: "", Type: "", Price: "", TaxInclude: true },
    ]);
  };
  const removeSundryField = (index) => {
    setSundryForms((prev) => prev.filter((_, i) => i !== index));
  };
  const handleSaveSundry = async () => {
    const validItems = sundryForms.filter(
      (item) => item.SundryName.trim() && item.Type !== "" && item.Price !== ""
    );
    if (validItems.length === 0) {
      alert("At least one complete sundry item is required");
      return;
    }
    try {
      // Prepare array of objects
      const lawnDtlArray = validItems.map((item) => ({
        LTSundry_LTMainID: parseInt(currentLawn.Lawn_ID, 10),
        LTSundry_SundryID: item.sundryId,
        LTSundry_EC_SundryID: item.EC_sundryId,
        LTSundry_TaxPercentage: item.SundryPercentage,
        LTSundry_Name: item.SundryName.trim(),
        LTSundry_Amount: parseFloat(item.Price),
        LTSundry_Type: item.Type,
        IsTaxInclud: item.TaxInclude, // Use the value from the form state
      }));

      const payload = {
        token: TOKEN_DATA,
        lawnSundry: lawnDtlArray, // sending as an array
      };
      const response = await fetch(`${BASEAPIURL}/InsertLawnTypeSundry`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const result = await response.json();
      if (!result.status)
        throw new Error(result.message || "Failed to insert sundry items");

      // Refresh and reset
      fetchSundryItems(currentLawn.Lawn_ID);
      setShowSundryModal(false);
      setSundryForms([
        { SundryName: "", Type: "", Price: "", TaxInclude: true },
      ]);
    } catch (err) {
      console.error("Error saving sundry:", err);
      alert(err.message || "Something went wrong while saving sundry");
    }
  };
  const handleRemoveSundry = async (index) => {
    const sundryToRemove = sundryItems[index];
    if (!window.confirm("Are you sure you want to delete this sundry item?"))
      return;
    try {
      const response = await fetch(
        `${BASEAPIURL}/DeleteSundry?SundryID=${
          sundryToRemove.LTSundry_ID
        }&Token=${encodeURIComponent(TOKEN_DATA)}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      if (!response.ok)
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      const result = await response.json();
      if (result.status) {
        fetchSundryItems(currentLawn.Lawn_ID);
        alert("Sundry item deleted successfully!");
      } else {
        throw new Error(result.message || "Failed to delete sundry item");
      }
    } catch (err) {
      setError("Failed to delete sundry item: " + err.message);
      console.error("Error deleting sundry item:", err);
    }
  };
  const fetchSundryList = async () => {
    setSundryListLoading(true);
    try {
      const response = await fetch(
        `${BASEAPIURL}/GetSundryList?Token=${token}`,
        {
          method: "GET",
          redirect: "follow",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      let data = [];
      if (Array.isArray(result)) {
        data = result;
      } else if (result && typeof result === "object") {
        if (result.data && Array.isArray(result.data)) {
          data = result.data;
        } else if (result.SundryList && Array.isArray(result.SundryList)) {
          data = result.SundryList;
        } else {
          Object.values(result).forEach((value) => {
            if (Array.isArray(value)) {
              data = value;
              return;
            }
          });
        }
      }
      setSundryList(data);
    } catch (error) {
      console.error("Error fetching sundry list:", error);
      setSundryList([]);
    } finally {
      setSundryListLoading(false);
    }
  };

  // Helper to format YYYY-MM-DD → DD-MM-YYYY
  const formatDateForDisplay = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}-${month}-${year}`;
  };

  // =================== RENDER ===================
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <span className="ms-3 text-muted">Loading lawns...</span>
      </div>
    );
  }
  console.log(facilities);
  return (
    <div className="container-fluid mt-4">
      {error && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="mb-0 text-dark">
              {type === "banquethall" || type === "Hall" ? "Hall" : "Lawn"}{" "}
              Booking Configuration
            </h3>
            <div></div>
          </div>
          <div className="table-responsive">
            <table className="table table-hover table-striped">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Booking</th>
                  <th>Member</th>
                  <th>Guest</th>
                  <th>Tax %</th>
                  <th>Tax Includede</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {priceList.length > 0 ? (
                  priceList.map((item, index) => (
                    <tr key={item.Lawn_ID}>
                      <td>{index + 1}</td>
                      <td>{item.Lawn_Name}</td>
                      <td>{item.BookingCount}</td>
                      <td>₹{item.MemberLawnPrice || item.LawnPrice}</td>
                      <td>₹{item.GuestLawnPrice}</td>
                      <td>{item.TaxPercentage}%</td>
                      <td>
                        {item.TaxIsInclude ? (
                          <span className="badge bg-success">Yes</span>
                        ) : (
                          <span className="badge bg-danger">No</span>
                        )}
                      </td>
                      <td>
                        <button
                          onClick={() => handleEdit(item)}
                          className="btn btn-sm btn-outline-primary me-2"
                        >
                          <i className="bi bi-pencil"></i> Edit
                        </button>
                        {/* <button
                          onClick={() => handleDelete(item.Lawn_ID)}
                          className="btn btn-sm btn-outline-danger"
                        >
                          <i className="bi bi-trash"></i> Delete
                        </button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center text-muted py-4">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Lawn Form Modal */}
      {showForm && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header bg-warning text-dark">
                <h5 className="modal-title">
                  {isEditing ? "Edit" : "Add"}{" "}
                  {type === "banquethall" || type === "Hall" ? "Hall" : "Lawn"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeForm}
                ></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row g-3 mb-4">
                    <div className="col-md-4">
                      <label className="form-label">Lawn Name *</label>
                      <input
                        type="text"
                        name="Lawn_Name"
                        value={currentLawn.Lawn_Name}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Type</label>
                      <input
                        type="text"
                        name="Type"
                        value={currentLawn.Type}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Booking Count *</label>
                      <input
                        type="number"
                        name="BookingCount"
                        value={currentLawn.BookingCount}
                        onChange={handleChange}
                        className="form-control"
                        min="1"
                        required
                      />
                    </div>
                  </div>
                  <div className="row g-3 mb-4">
                    <div className="col-md-4">
                      <label className="form-label">Location *</label>
                      <select
                        name="LocationID"
                        value={currentLawn.LocationID}
                        onChange={handleChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select Location</option>
                        {locations.map((loc) => (
                          <option key={loc.LocID} value={loc.LocID}>
                            {loc.LocName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Group Facility *</label>
                      {/* <select
                        name="GroupFacility"
                        value={selectedGroupFacility}
                        onChange={handleGroupFacilityChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select Group Facility</option>
                        {groupFacilities.map((group) => (
                          <option
                            key={group.FacilityGroupID}
                            value={group.FacilityGroupID}
                          >
                            {group.FacilityName}
                          </option>
                        ))}
                      </select> */}
                      <input
                        name="GroupFacility"
                        value={"Lawn & Hall"}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Facility *</label>
                      <select
                        name="FacilityID"
                        value={currentLawn.FacilityID}
                        onChange={handleChange}
                        className="form-control"
                        required
                      >
                        <option value="0">Select Facility</option>
                        {facilities.map((fac) => (
                          <option key={fac.Facility_ID} value={fac.Facility_ID}>
                            {fac.Facility_Name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* Pricing Section */}
                  <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">
                        <i className="bi bi-currency-rupee me-2"></i>Pricing
                        Information
                      </h5>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-info"
                        onClick={() => {
                          setPricingForm({
                            EffectiveDate: effectiveDate,
                            MemberLawnPrice: 0,
                            GuestLawnPrice: 0,
                            TaxPercentage: 0,
                            TaxIsInclude: false,
                            LawnTypeDtl_ID: 0,
                          });
                          setIsEditing(false);
                          setShowPricingModal(true);
                        }}
                      >
                        <i className="bi bi-plus me-1"></i> Add Price
                      </button>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Filter by Effective Date
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={pricingDateFilter}
                        onChange={(e) => setPricingDateFilter(e.target.value)}
                          min="1000-01-01"
                          max="9999-12-31"

                      />
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Effective Date</th>
                            <th>Member Price</th>
                            <th>Guest Price</th>
                            <th>Tax %</th>
                            <th>Tax Inc.</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(() => {
                            // Always filter by the global effectiveDate (even if pricingDateFilter is empty)
                            const targetDate =
                              pricingDateFilter || effectiveDate;
                            const filteredPricing = lawnSpecificPricing.filter(
                              (item) => {
                                // Avoid timezone issues: assume EffectiveDate is either "YYYY-MM-DD" or ISO string
                                const itemDate = item.EffectiveDate
                                  ? item.EffectiveDate.includes("T")
                                    ? item.EffectiveDate.split("T")[0]
                                    : item.EffectiveDate
                                  : "";
                                return itemDate === targetDate;
                              }
                            );
                            return filteredPricing.length > 0 ? (
                              filteredPricing.map((item, index) => (
                                <tr key={item.LawnTypeDtl_ID || index}>
                                  <td>
                                    {
                                      new Date(item.EffectiveDate)
                                        .toISOString()
                                        .split("T")[0]
                                    }
                                  </td>
                                  <td>₹{item.MemberRate}</td>
                                  <td>₹{item.GuestRate}</td>
                                  <td>{item.TaxPercentage}%</td>
                                  <td>
                                    {item.Is_TaxInclude ? (
                                      <span className="badge bg-success">
                                        Yes
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        No
                                      </span>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <button
                                      className="btn btn-sm btn-outline-info"
                                      onClick={() =>
                                        handleEditPricing({
                                          ...item,
                                          Lawn_ID: currentLawn.Lawn_ID,
                                          MemberLawnPrice: item.MemberRate,
                                          GuestLawnPrice: item.GuestRate,
                                          TaxIsInclude: item.Is_TaxInclude,
                                          LawnTypeDtl_ID: item.LawnTypeDtl_ID,
                                        })
                                      }
                                    >
                                      <i className="bi bi-pencil"></i> Edit
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="6"
                                  className="text-center text-muted"
                                >
                                  {pricingDateFilter
                                    ? `No pricing records found for ${pricingDateFilter}`
                                    : "No pricing records found for this lawn."}
                                </td>
                              </tr>
                            );
                          })()}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* Sundry Information Section */}
                  <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">🧾 Sundry Information</h5>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => openSundryModal()}
                      >
                        <i className="bi bi-plus-lg me-1"></i>Add Sundry
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Sundry Name</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Tax Includede</th> {/* Updated column header */}
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sundryItems.length > 0 ? (
                            sundryItems.map((item, index) => (
                              <tr key={index}>
                                <td>{item.LTSundry_Name}</td>
                                <td>{String(item.LTSundry_Optional)}</td>
                                <td>
                                  ₹{parseFloat(item.LTSundry_Amount).toFixed(2)}
                                </td>
                                <td>
                                  {String(item.TaxIsInclud).toLowerCase() ===
                                  "true" ? (
                                    <span className="badge bg-success">
                                      true
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      False
                                    </span>
                                  )}
                                </td>
                                <td className="text-center">
                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleRemoveSundry(index)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center text-muted"
                              >
                                {" "}
                                {/* Updated colspan */}
                                No sundry items added
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeForm}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-warning"
                    disabled={saving}
                  >
                    {saving ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Sundry Modal - RESTORED MULTIPLE ITEM FORM */}
      {showSundryModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">➕ Add Sundry Item</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowSundryModal(false);
                    // Reset the form state when closing
                    setSundryForms([
                      { SundryName: "", Type: "", Price: "", TaxInclude: true },
                    ]);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {sundryForms.map((form, idx) => (
                  <div key={idx} className="row g-2 mb-3 p-2 border rounded">
                    <div className="mb-3">
                      <Form.Label>
                        Select Sundry <span className="text-danger">*</span>
                      </Form.Label>
                      {sundryListLoading ? (
                        <div className="text-center">
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <small className="text-muted d-block mt-1">
                            Loading sundry items...
                          </small>
                        </div>
                      ) : (
                        <Form.Select
                          name={`sundry-${idx}`}
                          value={
                            JSON.stringify(form.selectedSundry) !==
                            JSON.stringify({})
                              ? JSON.stringify(form.selectedSundry)
                              : 0
                          }
                          onChange={(e) =>
                            handleSundrySelection(e.target.value, idx)
                          }
                          required
                        >
                          <option value="0">Select a sundry item</option>
                          {sundryList.map((sundry) => (
                            <option
                              key={sundry.LTSundry_SundryID || sundry.SundryID}
                              value={JSON.stringify(sundry)}
                            >
                              {sundry.LTSundry_Name ||
                                sundry.Sundry_Name ||
                                "Unnamed Sundry"}
                            </option>
                          ))}
                        </Form.Select>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Type</label>
                      <select
                        className="form-select"
                        value={form.Type}
                        onChange={(e) =>
                          handleSundryFormChange(idx, "Type", e.target.value)
                        }
                      >
                        <option value="">Select</option>
                        <option value="Additive">Additive</option>
                        <option value="Subtractive">Subtractive</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Amount (₹)</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={form.Price}
                        onChange={(e) =>
                          handleSundryFormChange(
                            idx,
                            "Price",
                            e.target.value ? parseFloat(e.target.value) : ""
                          )
                        }
                        placeholder="0.00"
                      />
                    </div>
                    {/* Added TaxInclude Checkbox */}
                    <div className="col-md-3">
                      <label className="form-label">Tax Includede</label>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={form.TaxInclude}
                          onChange={(e) =>
                            handleSundryFormChange(
                              idx,
                              "TaxInclude",
                              e.target.checked
                            )
                          }
                        />
                        <label className="form-check-label">Yes</label>
                      </div>
                    </div>
                    <div className="col-md-1 d-flex align-items-end">
                      {sundryForms.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeSundryField(idx)}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={addSundryField}
                  >
                    + Add Another
                  </button>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowSundryModal(false);
                    setSundryForms([
                      { SundryName: "", Type: "", Price: "", TaxInclude: true },
                    ]);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSaveSundry}
                >
                  Save All
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Pricing Modal */}
      {showPricingModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header bg-info text-white">
                <h5 className="modal-title">
                  {isEditing ? "Edit Pricing" : "Add Pricing"}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closePricingModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label">Effective Date *</label>
                    <input
                      type="date"
                      name="EffectiveDate"
                      value={pricingForm.EffectiveDate}
                      onChange={handlePricingChange}
                      className="form-control"
                        min="1000-01-01"
                        max="9999-12-31"

                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Member Price *</label>
                    <input
                      type="number"
                      step="0.01"
                      name="MemberLawnPrice"
                      value={pricingForm.MemberLawnPrice}
                      onChange={handlePricingChange}
                      min="0"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label">Guest Price *</label>
                    <input
                      type="number"
                      step="0.01"
                      name="GuestLawnPrice"
                      value={pricingForm.GuestLawnPrice}
                      onChange={handlePricingChange}
                      min="0"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tax Percentage</label>
                    <input
                      type="number"
                      step="0.01"
                      name="TaxPercentage"
                      value={pricingForm.TaxPercentage}
                      onChange={handlePricingChange}
                      min="0"
                      max="100"
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row g-3 mb-4">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        name="TaxIsInclude"
                        checked={pricingForm.TaxIsInclude}
                        onChange={handlePricingChange}
                        className="form-check-input"
                        id="taxIncludeCheck"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="taxIncludeCheck"
                      >
                        Tax Included in Price
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closePricingModal}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn ${isEditing ? "btn-primary" : "btn-info"}`}
                  onClick={isEditing ? handleUpdatePricing : handleSavePricing}
                  disabled={saving}
                >
                  {saving
                    ? "Saving..."
                    : isEditing
                    ? "Update Pricing"
                    : "Save Pricing"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LawnManagement;
